import { createContext, useContext } from "react";

export type ImportContextType = {
  onUploadCSV: (acceptedFiles: File[]) => void;
  isUploading: boolean;
  setIsUploading: (value: boolean) => void;
  isSuccess: boolean;
  setIsSuccess: (value: boolean) => void;
  isError: boolean;
  setIsError: (value: boolean) => void;
  setShowImportMappingPage: (value: boolean) => void;
  showImportMappingPage: boolean;
  csvFile: {
    name: string;
    data: string[][];
  };
  setCsvFile: (value: { name: string; data: string[][] }) => void;
  createExcelFileFromData: (
    newData: unknown[][],
    tableName: string | undefined,
  ) => Promise<File>;
  savedUploadedFile: {
    name: string;
    data: string[][];
  };
};

export const useImport = () => {
  const context = useContext(ImportContext);
  if (!context) {
    throw new Error("useImport must be used within a ImportProvider");
  }

  return context;
};

const ImportContext = createContext<ImportContextType | undefined>(undefined);
export default ImportContext;
